import React, { useState } from "react";
import { db } from "./firebase";
import { doc, setDoc, collection, query, where, getDocs, serverTimestamp } from "firebase/firestore";
import { getFunctions, httpsCallable } from "firebase/functions";

function DisplayName({ user, onComplete }) {
  const [name, setName] = useState("");
  const [error, setError] = useState("");
  const [saving, setSaving] = useState(false);

  const save = async () => {
    setError("");
    const trimmed = name.trim();
    if (!trimmed) { setError("Please enter a display name."); return; }
    if (trimmed.length < 2) { setError("Name must be at least 2 characters."); return; }
    if (trimmed.length > 20) { setError("Name must be 20 characters or less."); return; }
    if (!/^[a-zA-Z0-9_ ]+$/.test(trimmed)) { setError("Only letters, numbers, spaces and underscores allowed."); return; }
    setSaving(true);
    try {
      const q = query(collection(db, "users"), where("displayName", "==", trimmed));
      const snap = await getDocs(q);
      if (!snap.empty) { setError("That name is already taken. Please choose another."); setSaving(false); return; }
      await setDoc(doc(db, "users", user.uid), {
        uid: user.uid, displayName: trimmed, email: user.email || "", createdAt: serverTimestamp()
      });
      if (user.email) {
        try {
          const fn = getFunctions();
          await httpsCallable(fn, "sendWelcomeEmail")({ toEmail: user.email, displayName: trimmed });
        } catch (e) { console.error("Welcome email failed:", e); }
      }
      onComplete(trimmed);
    } catch (e) { setError("Error saving name. Please try again."); console.error(e); }
    setSaving(false);
  };

  return (
    <div className="animate-fade-in" style={{ maxWidth: 420, margin: "0 auto", paddingTop: 20 }}>
      <div className="card" style={{ padding: 32, textAlign: "center" }}>
        <div style={{ fontSize: 52, marginBottom: 12 }} className="animate-float">🏷️</div>
        <div style={{ fontFamily: "'Bebas Neue', sans-serif", fontSize: 28, color: "#FFD700", letterSpacing: 2, marginBottom: 8 }}>
          PICK YOUR NAME
        </div>
        <p style={{ color: "rgba(255,255,255,0.5)", fontSize: 14, marginBottom: 24, lineHeight: 1.5 }}>
          This is what other players will see on the leaderboard. Make it count.
        </p>
        <input
          value={name} onChange={(e) => setName(e.target.value)}
          onKeyDown={(e) => e.key === "Enter" && save()}
          placeholder="e.g. GoalMachine99" maxLength={20} autoFocus className="input"
          style={{ textAlign: "center", fontSize: 18, letterSpacing: 1, marginBottom: 6 }}
        />
        <div style={{ fontSize: 12, color: "rgba(255,255,255,0.3)", textAlign: "right", marginBottom: 16 }}>{name.length}/20</div>
        {error && <p className="error-text" style={{ marginBottom: 12 }}>{error}</p>}
        <button onClick={save} disabled={saving} className="btn btn-primary btn-full btn-lg" style={{ borderRadius: 10 }}>
          {saving ? "Checking..." : "Let's Go! 🚀"}
        </button>
        <p style={{ fontSize: 11, color: "rgba(255,255,255,0.2)", marginTop: 12 }}>
          Letters, numbers, spaces and underscores only
        </p>
      </div>
    </div>
  );
}

export default DisplayName;
